export const culture = {
    locale: "nl-NL",
    monthNames: ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'],
    monthNamesShort: ['Jan', 'Feb', 'Mrt', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
    dayNames: ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'],
    dayNamesShort: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'],
    dayNamesMin: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'],
    dateFormat: 'dd-mm-yy',
    datePlaceholder: 'dd-mm-jjjj',
    weekHeader: 'Wk',
    firstDay: 1,
    monthDayFormat: 'dd-mm',
    shortFormat: "d M",
    mediumFormat: "d M, y",
    mediumFullYearFormat: "d M, yy",
    monthShortFormat: "M yy",
    yearFormat: "yy",
    FullFormat: "dd M, yy",
    LongTimeFormat: 'HH:mm:ss',
    shortTimeFormat: 'HH:mm',
    decimalSeparator: ",",
    currencyDecimalSeparator: ',',
    currencyGroupSeparator: '.',
    moneyWithCurrencyFormat: "{c} {v}",
    from: 'Van',
    by: 'Door',
    fromFormat: 'Van {0}',
    byFormat: 'Door {0}'
};

export const datepicker = {
    ...culture,
    closeText: 'Klaar',
    prevText: 'Vorige',
    nextText: 'Volgende',
    currentText: 'Vandaag',
    isRTL: false,
    showMonthAfterYear: false,
    yearSuffix: ''
};